import { api } from "@services/api";
import { createContext, type ReactNode, useCallback } from "react";
import { toast } from '@services/toast';

type UserProviderProps = {
  children: ReactNode;
}

interface UserData {
  id: string;
  name: string;
  email: string;
  cnpjCpf: string;
  address?: {
    city?: string;
    state?: string;
  }
  status?: boolean;
  password: string;
  refreshToken?: string;
}

interface ListParams {
  _page: number;
  _limit?: number;
  _sort?: string;
  _filter?: {};
  _order?: string;
  _embed?: string;
  q?: string;
}

type UserContextData = {
  getUser?: (id: string) => Promise<UserData>;
  // user: string | undefined;
  // users: UserModel[] | undefined;
  createUser: (data: Omit<UserData, 'id'>) => Promise<void>;
  editUser?: (id: string, data: Partial<Omit<UserData, 'id'>>) => Promise<void>;
  deleteUser?: (id: string) => Promise<void>;
  listUsers?: (params: ListParams) => Promise<Readonly<UserData[]>>
};

const UserContext = createContext({} as UserContextData)

export function UserProvider({ children }: UserProviderProps) {
  const createUser = useCallback(
    async (data: Omit<UserData, 'id'>) => {
      await api.post('/users', { ...data })
        .then(() => {
          toast('Usuário criado com sucesso', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            type: 'success',
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        })
        .catch(error => {
          toast.errorFrom(error, 'Usuário não pode ser criado', undefined, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            type: 'error',
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        })
    },
    []);

  return (
    <UserContext.Provider value={{ createUser }}>
      {children}
    </UserContext.Provider>
  )
}
